import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SiteFooter } from '../ui/SiteFooter';
import { SiteHeader } from '../ui/SiteHeader';
interface PractitionerFlowShellProps {
  /** 0 = Account, 1 = Membership, 2 = Get the app */
  currentStep: 0 | 1 | 2;
  children: React.ReactNode;
}
const steps = ['Create account', 'Choose membership', 'Open the app'];
export function PractitionerFlowShell({
  currentStep,
  children
}: PractitionerFlowShellProps) {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal flex flex-col" data-id="element-571" data-mp="3voduqlkxxljg">
      {/* Navigation — matches the site nav */}
      <SiteHeader currentPath="/practitioners" data-id="element-572" data-mp="3lux0xhkt06fs" />

      <main className="flex-1 pt-10 md:pt-14 pb-24" data-id="element-573" data-mp="3gy6meyondiwh">
        <ol aria-label="Signup progress" className="max-w-xl mx-auto px-6 flex items-center justify-center gap-2 sm:gap-3" data-id="element-574" data-mp="3gxerlq2vjp79">
          {steps.map((label, index) => {
          const done = index < currentStep;
          const active = index === currentStep;
          return <li key={label} aria-current={active ? 'step' : undefined} className="flex items-center gap-2 sm:gap-3" data-id="element-575" data-mp="2bo7g5ma0691s" data-mpi={index}>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${done ? 'bg-purple-700 text-white' : active ? 'border-2 border-purple-700 text-purple-800 bg-white' : 'border border-charcoal/20 text-charcoal/45 bg-white'}`} data-id="element-576" data-mp="21vrzqtectsj0">
                  {done ? <CheckIcon aria-hidden="true" className="w-3.5 h-3.5" data-id="element-577" data-mp="1nvh7blxec5vq" /> : index + 1}
                </span>
                <span className={`hidden sm:inline whitespace-nowrap text-sm ${active ? 'font-semibold text-charcoal' : 'text-charcoal/55'}`} data-id="element-578" data-mp="3dc8hwuhamn9k">
                  {label}
                  {done && <span className="sr-only" data-id="element-579" data-mp="3ftaclqdl4rsl"> (complete)</span>}
                </span>
                {index < steps.length - 1 && <span aria-hidden="true" className="h-px w-6 sm:w-10 bg-charcoal/15" data-id="element-580" data-mp="36u5cwgqaeseu" />}
              </li>;
        })}
        </ol>

        <div className="mt-12 md:mt-16" data-id="element-581" data-mp="31y6vjd3dmanx">{children}</div>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-582" data-mp="3douxjw6wcg7" />
    </div>;
}